var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569 13.431-30 30-30 16.568 0 29.999 13.431 29.999 30 0 16.568-13.431 29.999-29.999 29.999C13.431 29.999 0 16.568 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(79.093 382.92)",
    fill: "#fb923c",
    "data-original": "#fb923c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 116.592 135.796 38.787-45.176 66.154 82.901 73.654-92.301c17.014 17.71 39.538 30.086 64.813 34.374V300H0Zm101.593 188.296c-16.57 0-30 13.431-30 30 0 16.568 13.43 29.999 30 29.999 16.568 0 29.999-13.431 29.999-29.999 0-16.569-13.431-30-29.999-30",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(7.5 164.625)",
    fill: "#B8D0FF",
    "data-original": "#B8D0FF",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-66.154-82.901 77.804-90.62h29.317c0 31.527 12.443 60.148 32.687 81.219z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(229.033 338.147)",
    fill: "#06D6A0",
    "data-original": "#06D6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22.5c0 31.527 12.443 60.148 32.688 81.22L41.057 98.929C15.695 73.628 0 38.643 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(247.5 164.625)",
    fill: "#06D6A0",
    "data-original": "#06D6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-38.787 45.176L-155.379-90.62H77.805Z",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(162.879 255.245)",
    fill: "#06D6A0",
    "data-original": "#06D6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-64.756 52.494-117.25 117.25-117.25S234.5-64.756 234.5 0s-52.494 117.25-117.25 117.25C52.472 117.25 0 64.722 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(270 164.625)",
    fill: "#FFD166",
    "data-original": "#FFD166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-69.354 59.716-123.26 128.5-116.71C69.023-111.048 22.5-60.961 22.5 0c0 60.93 46.505 111.046 106 116.71C59.721 123.26 0 69.347 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(270 164.625)",
    fill: "#FFD166",
    "data-original": "#FFD166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-37.508M0 30V15m-360 94.408v37.499H0V45m-97.5-198.093H-360v247.5",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(367.5 317.718)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 116.592 135.796L233.184 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(7.5 164.625)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 66.154 82.901 73.658-92.304",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(162.879 255.245)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c16.568 0 29.999-13.431 29.999-29.999 0-16.569-13.431-30-29.999-30-16.569 0-30 13.431-30 30C-30-13.431-16.569 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(109.093 412.92)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15m15 0h15",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2.613,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(300 434.626)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2.613,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v80.46M43.069-7.5V-30h-86.138v22.5m3.75 48.64L0 80.46l39.319-39.32",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(387.25 139.394)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c64.756 0 117.25-52.495 117.25-117.25C117.25-182.006 64.756-234.5 0-234.5s-117.25 52.494-117.25 117.25C-117.25-52.495-64.756 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(387.25 281.875)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImages);
export default __webpack_public_path__ + "static/media/upload-images.c22de609444eb52e1419ddc579eda6df.svg";
export { ForwardRef as ReactComponent };